import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { AuditTrailCenter } from '@/components/audit/AuditTrailCenter'
import { PageHeading } from '@/components/layout/PageHeading'
import { criteriaFromUrl, criteriaToUrl, type AuditCriteria } from '@/lib/auditCenter'

/**
 * The Audit Trail Center (z8nrz7dq6q): every audit trail in the tenant — user,
 * storage, product, inventory, equipment, procedures, fields — searched from
 * one place instead of record by record.
 *
 * The search lives in the URL, so a reviewer can bookmark it, send it to QA,
 * or come back to it after following a record into its own trail.
 */
export function AuditTrailCenterPage() {
  const [params, setParams] = useSearchParams()
  const key = params.toString()
  // Keyed on the query string, so a new object only when the search changed —
  // the component treats a new object as a new search.
  const criteria = useMemo(() => criteriaFromUrl(new URLSearchParams(key)), [key])
  const onCriteriaChange = (next: AuditCriteria) => setParams(criteriaToUrl(next))

  return (
    <div className='flex w-full flex-col gap-6 px-10 py-6'>
      <PageHeading title='Audit Trail Center' description='Search one audit trail at a time.' />
      <AuditTrailCenter criteria={criteria} onCriteriaChange={onCriteriaChange} tableId='audit-center-page' />
    </div>
  )
}
